/**
 * Collection / search filters: tags each filter list with its kind so CSS can style it
 * (colour rows with real colour circles, chip grid for sizes / gender / type), and adds the
 * colour circles. Horizon re-renders the filters after every change, so this re-runs on DOM updates.
 */
import { paint } from './anja-swatches.js';

// Filter values that come from Shopify's product taxonomy and stay English on the Arabic storefront.
const AR_VALUES = { Unisex: 'للجنسين', Boys: 'أولاد', Girls: 'بنات', Male: 'ذكر', Female: 'أنثى' };

function decorate() {
  if (document.documentElement.lang.startsWith('ar')) {
    document.querySelectorAll('.facets__inputs-list .checkbox__label-text, .facets__pill').forEach((el) => {
      const text = el.textContent?.trim() || '';
      if (AR_VALUES[text]) el.textContent = AR_VALUES[text];
    });
  }
  document.querySelectorAll('.facets__inputs-list:not([data-anja-facet])').forEach((list) => {
    const input = /** @type {HTMLInputElement | null} */ (list.querySelector('input[name]'));
    if (!input) return;
    const isColor = /option\.colou?r|\.color$/i.test(input.name);
    list.setAttribute('data-anja-facet', isColor ? 'color' : 'chips');
    if (!isColor) return;
    list.querySelectorAll('li').forEach((li) => {
      const field = /** @type {HTMLInputElement | null} */ (li.querySelector('input'));
      const bg = field && paint(field.value);
      if (bg) /** @type {HTMLElement} */ (li).style.setProperty('--anja-dot', bg);
    });
  });
}

decorate();
let queued = false;
new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    decorate();
  });
}).observe(document.body, { childList: true, subtree: true });
